import { createContext, useContext } from 'react'

export interface CompleteSignupNudgeContextValue {
  showPopover: boolean
  openModal: () => void
  dismiss: () => void
}

export const CompleteSignupNudgeContext = createContext<CompleteSignupNudgeContextValue | null>(
  null
)

export function useCompleteSignupNudge() {
  return useContext(CompleteSignupNudgeContext)
}
